/* components/patterns/Breadcrumbs.jsx — хлебные крошки шапки раздела.
   items=[{label, to?}] — элементы с `to` кликабельны (Link на роут), последний и
   любой без `to` — текущая страница (не ссылка). Рендерится в eyebrow-слоте
   PageHeader (моно-надзаголовок). Разделитель — chevron. */
import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { RR } from '../../lib/router.jsx';

const { Link } = RR;

function Breadcrumbs({ items = [], className }) {
  const crumbs = items.filter(Boolean);
  if (!crumbs.length) return null;
  return (
    <nav className={'breadcrumbs t-eyebrow' + (className ? ' ' + className : '')} aria-label="Хлебные крошки">
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <Icon name="chevron-right" size={12} className="breadcrumbs__sep" aria-hidden="true" />}
            {c.to && !last
              ? <Link to={c.to} className="breadcrumbs__link">{c.label}</Link>
              : <span className="breadcrumbs__current" aria-current={last ? 'page' : undefined}>{c.label}</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export { Breadcrumbs };
